import { Button, type ButtonProps, styled } from "@mui/material";
import { forwardRef } from "react";
import type { To } from "react-router";

type LinkButtonProps = ButtonProps & {
  component?: React.ElementType;
  to?: To;
  target?: string;
};

export const LinkButton = styled(
  forwardRef<HTMLButtonElement, LinkButtonProps>(({ children, ...props }, ref) => (
    <Button ref={ref} variant="denseUnderlined" sx={{ color: "secondary.main" }} {...props}>
      <span className="button-text">{children}</span>
    </Button>
  )),
)(() => ({
  mt: 0,
  flexGrow: 0,
  justifyContent: "flex-start",
  minWidth: 0,
  maxWidth: "100%",
  width: "fit-content",

  "& .button-text": {
    display: "inline-block",
    maxWidth: "100%", // Prevents expansion
    whiteSpace: "nowrap", // Prevents wrapping
    overflow: "hidden", // Hides overflowing text
    textOverflow: "ellipsis", // Displays "..."
  },
}));
